export const GRAY_1 = '#F0F0F1';

export const GRAY_2 = '#D9D9D9';

export const BLACK_1 = '#484848';

export const PINK_1 = '#FACACF';

export const PURPLE_1 = '#DAD0E6';

export const BACKGROUND = '#f6f6f8';
